import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-train-yesno-dialog',
  templateUrl: './train-yesno-dialog.component.html',
  styleUrls: ['./train-yesno-dialog.component.scss']
})
export class TrainYesnoDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<TrainYesnoDialogComponent>,
  ) { }

  ngOnInit() {
  }

  /**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
  	this.dialogRef.close(true); // Keep only this row
	}

}
